import {h, Fragment} from "preact"
import Product from "./Product"
import { useAppState, useProductFilters } from "@nosto/preact"
import { useEffect } from "preact/hooks";

export default function Products() {
    const { response: { products }, loading } = useAppState();
    const docCount = products?.total ?? 0;
    const isExchangeCollection = (products?.categoryPath === "The Frye Exchange");
    const { filters } = useProductFilters();

    useEffect(() => {
        if(window.nostojs){
            window.nostojs(api => api.loadRecommendations())
        }
    }, [products])
    return (
        <>
            <div
                class="ns-prod-count"
                data-nosto-element="totalResults"
            >
                {docCount} Products
            </div>
            <div class={`ns-product-grid ${filters?.length > 0 ? "ns-filters-applied" : ""}`} style={loading ? "opacity: 0.3;" : ""}>
                {products.hits.map((hit, index) => (
                    <Product 
                        product={hit} 
                        key={hit.productId || index} 
                        isExchangeCollection={isExchangeCollection}
                    />
                ))}
            </div>
        </>
    )
}
